import {
  Alert,
  AlertTitle,
  HStack,
  Icon,
  Spinner,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

interface Props {
  status: 'idle' | 'loading' | 'success' | 'error';
  isPlural?: boolean;
}

const AnvaSendOfferStatus = ({ status, isPlural }: Props) => {
  const { t } = useTranslation();
  const isLoading = status === 'loading';
  const isError = status === 'error';
  const isSuccess = status === 'success';
  const pluralTranslationKey = isPlural ? 'PLURAL' : 'SINGULAR';

  return (
    <Alert status={status === 'idle' || status === 'loading' ? 'info' : status}>
      <HStack spacing="2">
        {isLoading && <Spinner size="sm" color="info.main" mr="1" />}
        {isError && (
          <Icon name="GeneralStatusWarningTriangle" color="danger.main" />
        )}
        {isSuccess && (
          <Icon name="GeneralStatusSuccessCheckmark" color="success.dark" />
        )}
        <AlertTitle fontWeight="bold">
          {
            {
              loading: t(
                `FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_STATUS_LOADING_${pluralTranslationKey}`,
              ),
              error: t(
                `FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_STATUS_ERROR_${pluralTranslationKey}`,
              ),
              success: t(
                `FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_STATUS_SUCCESS_${pluralTranslationKey}`,
              ),
              idle: t(
                `FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_STATUS_LOADING_${pluralTranslationKey}`,
              ),
            }[status]
          }
        </AlertTitle>
      </HStack>
    </Alert>
  );
};

export default AnvaSendOfferStatus;
